import React, { useState } from 'react';
import Styled from '../styles/AdminFVContainer.styled';
import StyledForm from '../styles/FormFV.styled';
import { MdClose } from 'react-icons/md';
import Colors from 'enums/Colors';
import ReactQuill from 'react-quill';
import { Input, Select, Switch } from 'antd';
import { IFormFerramentaVideo } from '../interfaces/components/IFormFerramentaVideo';
import * as Yup from 'yup';
import { LoadingSpinner } from 'components/loadings/LoadingSpinner';
import Loading from 'components/Loading';

const validationSchema = Yup.object().shape({
    title: Yup.string().required('Título é obrigatório').max(200, 'Máximo de 200 caracteres'),
    url: Yup.string().required('URL é obrigatória').max(50, 'Máximo de 50 caracteres'),
    alt_url: Yup.string().max(100, 'Máximo de 100 caracteres'),
});

const FormFerramentaVideo = ({
    formVisible,
    handleSubmit,
    setForm,
    setFormVisible,
    form,
    listQuerySolutions,
    handleChange,
    loading
}: IFormFerramentaVideo) => {
    const [errors, setErrors] = useState<any>({});


    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await validationSchema.validate(form, { abortEarly: false });
            setErrors({});
            handleSubmit(e);
        } catch (err: any) {
            if (err.inner) {
                const formErrors: any = {};
                err.inner.forEach((validationError: any) => {
                    formErrors[validationError.path] = validationError.message;
                });
                setErrors(formErrors);
            }
        }
    };

    return (
        <StyledForm.FormFerramentaVideo onSubmit={onSubmit} active={formVisible}>
            <MdClose
                style={{ cursor: 'pointer', alignSelf: 'flex-end', justifySelf: 'flex-end' }}
                size={32}
                color={Colors.Blue}
                onClick={() => setFormVisible(false)}
            />
            <Styled.FormGroup>
                <Styled.Label htmlFor="title">Título</Styled.Label>
                <Input
                    size="large"
                    name="title"
                    id="title"
                    value={form.title}
                    onChange={handleChange}
                    maxLength={200}
                    showCount
                    required
                    placeholder="Digite o título"
                />
                {errors.title && <Styled.ErrorText>{errors.title}</Styled.ErrorText>}
            </Styled.FormGroup>
            <Styled.FormGroup>
                <Styled.Label htmlFor="description">Descrição</Styled.Label>
                <ReactQuill
                    value={form.description}
                    onChange={v => {
                        setForm((prev: any) => ({ ...prev, description: v }));
                    }}
                    placeholder="Digite a descrição"
                    style={{
                        backgroundColor: 'white',
                        color: 'black',
                    }}
                />
            </Styled.FormGroup>
            <Styled.FormTwoGrid>
                <Styled.FormGroup>
                    <Styled.Label htmlFor="url">URL</Styled.Label>
                    <Input
                        size="large"
                        name="url"
                        id="url"
                        value={form.url}
                        onChange={handleChange}
                        required
                        maxLength={50}
                        showCount
                        placeholder="Digite a URL"
                    />
                    {errors.url && <Styled.ErrorText>{errors.url}</Styled.ErrorText>}
                </Styled.FormGroup>
                <Styled.FormGroup>
                    <Styled.Label htmlFor="altUrl">Texto alternativo da URL</Styled.Label>
                    <Input
                        size="large"
                        name="altUrl"
                        id="altUrl"
                        value={form.altUrl}
                        onChange={handleChange}
                        maxLength={100}
                        showCount
                        placeholder="Digite o texto alternativo da URL"
                    />
                    {errors.altUrl && <Styled.ErrorText>{errors.altUrl}</Styled.ErrorText>}
                </Styled.FormGroup>
            </Styled.FormTwoGrid>
            <Styled.FormGroup>
                <Styled.Label htmlFor="solution">Solução</Styled.Label>
                <Select
                    id="solution"
                    value={form?.codigoSolucao?.id || form?.codigoSolucao || ''}
                    onChange={value => setForm((prev: any) => ({ ...prev, codigoSolucao: value }))}
                    size="large"
                >
                    {[{ id: '', nome: 'Nenhuma solução' }, ...(listQuerySolutions ?? [])].map(opt => (
                        <Select.Option key={opt.id} value={opt.id}>
                            {opt.nome}
                        </Select.Option>
                    ))}
                </Select>
                {errors.codigoSolucao && <Styled.ErrorText>{errors.codigoSolucao}</Styled.ErrorText>}
            </Styled.FormGroup>
             <Styled.FormGroup>
                    <Styled.Label htmlFor="notAccessibility">Ferramenta sem acessibilidade</Styled.Label>
                    <Switch
                        id="notAccessibility"
                        checked={form.notAccessibility}
                        onChange={checked => setForm((prev: any) => ({ ...prev, notAccessibility: checked }))}
                        style={{maxWidth: "14px"}}
                    />
                    {errors.notAccessibility && <Styled.ErrorText>{errors.notAccessibility}</Styled.ErrorText>}
                </Styled.FormGroup>
            <Styled.Button disabled={loading} type="submit">
                {loading ? (
                    <div className="loaderConteudo" style={{ width: '26px' }} />
                ) : form.id > 0 ? (
                    'Atualizar Ferramenta'
                ) : (
                    'Criar Ferramenta'
                )}
            </Styled.Button>
        </StyledForm.FormFerramentaVideo>
    );
};

export default FormFerramentaVideo;
